// src/components/TransaccionesPagos.jsx
import { useState, useEffect, useRef } from "react";
import clienteAxios from "../../axios";
import Dasboard from "../dasboard/dashboard";
import ModalConfirm from '../ModalConfirm';
import { useNavigate } from "react-router-dom";
import MetodosPago from "./MetodosPago";
import Facturas from "./Facturas";

const TransaccionesPagos = () => {    
    const [transacciones, setTransacciones] = useState([]);
    const [nuevaTransaccion, setNuevaTransaccion] = useState({
        idusuario: "", metodo_pago_id: "", monto: "", estado: "Pendiente"
    });
    const [editandoTransaccionId, setEditandoTransaccionId] = useState(null);
    const [transaccionEditada, setTransaccionEditada] = useState({
        idusuario: "", metodo_pago_id: "", monto: "", estado: "Pendiente"
    });
    const [transaccionSeleccionada, setTransaccionSeleccionada] = useState(null);
    const [mensajeExito, setMensajeExito] = useState(false);

    const [busqueda, setBusqueda] = useState(""); // Nuevo estado para la barra de búsqueda

    const [showConfirmModal, setShowConfirmModal] = useState(false);
    const [transaccionAEliminar, setTransaccionAEliminar] = useState(null);
    const [mostrarFormulario, setMostrarFormulario] = useState(false);
    const [componenteActivo, setComponenteActivo] = useState(null); // Controla el componente activo
    const formularioRef = useRef(null);
    const inputRef = useRef(null);
    const navigate = useNavigate();

    useEffect(() => {
        obtenerTransacciones();
    }, []);

 
    // Obtener lista de transacciones
    const obtenerTransacciones = async () => {
        try {
            const response = await clienteAxios.post("/api/sp", {
                sp: "tools",
                op: "Listar",
                modulo: "transacciones_pagos"
            });
            setTransacciones(response.data.data[0]);
        } catch (error) {
            console.log(error);
        }
    };

    // Función para manejar el cambio en la barra de búsqueda
    const handleBusqueda = (e) => {
        setBusqueda(e.target.value.toLowerCase());
    };

    // Filtrar las transacciones en función del término de búsqueda
    const transaccionesFiltradas = transacciones.filter((transaccion) => {
        return (
            transaccion.idusuario.toString().toLowerCase().includes(busqueda) ||
            transaccion.metodo_pago_id.toString().toLowerCase().includes(busqueda) ||
            (transaccion.fecha_pago || "").toLowerCase().includes(busqueda) ||
            transaccion.monto.toString().toLowerCase().includes(busqueda) ||
            transaccion.estado.toLowerCase().includes(busqueda)
        );
    });

    // Función para agregar una nueva transacción
    const handleAgregarTransaccion = async (e) => {
        e.preventDefault();
        try {
            await clienteAxios.post("/api/sp", {
                sp: "tools",
                op: "Agregar",
                modulo: "transacciones_pagos",
                ...nuevaTransaccion
            });

            setNuevaTransaccion({ idusuario: "", metodo_pago_id: "", monto: "", estado: "Pendiente" });
            setMensajeExito(true);
            setTimeout(() => setMensajeExito(false), 3000);
            obtenerTransacciones();
            setMostrarFormulario(false);
        } catch (error) {
            console.log(error);
        }
    };

    // Función para editar una transacción existente
    const editarTransaccion = (idTransaccion, transaccionActual) => {
        setEditandoTransaccionId(idTransaccion);
        setTransaccionEditada(transaccionActual);
        setTransaccionSeleccionada(idTransaccion);
        setTimeout(() => {
            if (inputRef.current) {
                inputRef.current.focus();
                inputRef.current.setSelectionRange(0, 0);
            }
        }, 0);
    };

    // Función para guardar los cambios de la transacción editada
    const guardarTransaccionEditada = async (idTransaccion) => {
        try {
            await clienteAxios.post("/api/sp", {
                sp: "tools",
                op: "Actualizar",
                modulo: "transacciones_pagos",
                id: idTransaccion,
                ...transaccionEditada
            });

            setEditandoTransaccionId(null);
            setTransaccionSeleccionada(null);
            obtenerTransacciones();
        } catch (error) {
            console.log(error);
        }
    };

    // Función para confirmar la eliminación de una transacción
    const confirmarEliminarTransaccion = (idTransaccion) => {
        setShowConfirmModal(true);
        setTransaccionAEliminar(idTransaccion);
    };

    const ejecutarEliminarTransaccion = async () => {
        try {
            await clienteAxios.post("/api/sp", {
                sp: "tools",
                op: "Eliminiar",
                modulo: "transacciones_pagos",
                id: transaccionAEliminar
            });

            setShowConfirmModal(false);
            obtenerTransacciones();
        } catch (error) {
            console.log(error);
        }
    };

    const cancelarSeleccion = () => {
        setTransaccionSeleccionada(null);
        setEditandoTransaccionId(null);
        setComponenteActivo(null);
    };

    const handleMostrarFormulario = () => {
        setMostrarFormulario(true);
        setTimeout(() => {
            formularioRef.current.scrollIntoView({ behavior: 'smooth' });
        }, 100);
    };

    return (
        <>
            <ModalConfirm
                show={showConfirmModal}
                message="¿Estás seguro de que quieres eliminar esta transacción?"
                onConfirm={ejecutarEliminarTransaccion}
                onCancel={() => setShowConfirmModal(false)}
            />

            
                <>
                    <Dasboard  />

                    <main className="-mt-32">
                        <div className="mx-auto max-w-7xl px-4 pb-12 sm:px-6 lg:px-8">
                            <div className="rounded-lg bg-white px-5 py-6 shadow sm:px-6 max-w-full overflow-hidden">
                                <h2 className="text-2xl font-bold mb-6 mt-4">Transacciones de Pagos</h2>


                                {/* Barra de búsqueda */}
                                <input
                                    type="text"
                                    placeholder="Buscar transacción..."
                                    value={busqueda}
                                    onChange={handleBusqueda}
                                    className="border rounded-lg p-2 mb-4 w-full"
                                />
                                <ul>
                                    {transaccionesFiltradas.map((transaccion) => (
                                        <li key={transaccion.id} className="border-4 p-4 rounded-lg mb-4 cursor-pointer"
                                            onClick={() => setTransaccionSeleccionada(transaccion.id)}>

                                            <div className="relative">
                                                {transaccionSeleccionada === transaccion.id && (
                                                    <button
                                                        onClick={(e) => {
                                                            e.stopPropagation();
                                                            cancelarSeleccion();
                                                        }}
                                                        className="absolute top-[-1rem] right-0 text-gray-500 hover:text-red-500 p-2 text-3xl"
                                                    >
                                                        &times;
                                                    </button>
                                                )}
                                                {editandoTransaccionId === transaccion.id ? (
                                                    <div className="flex flex-col">
                                                        <h3 className="font-semibold">ID Usuario:</h3>
                                                        <input
                                                            type="number"
                                                            ref={inputRef}
                                                            value={transaccionEditada.idusuario}
                                                            onChange={(e) => setTransaccionEditada({ ...transaccionEditada, idusuario: e.target.value })}
                                                            className="border rounded-lg p-2 mb-2"
                                                        />

                                                        <h3 className="font-semibold">Método de Pago:</h3>
                                                        <input
                                                            type="text"
                                                            value={transaccionEditada.metodo_pago_id}
                                                            onChange={(e) => setTransaccionEditada({ ...transaccionEditada, metodo_pago_id: e.target.value })}
                                                            className="border rounded-lg p-2 mb-2"
                                                            maxLength={20}
                                                        />

                                                        <h3 className="font-semibold">Monto:</h3>
                                                        <input
                                                            type="number"
                                                            value={transaccionEditada.monto}
                                                            onChange={(e) => setTransaccionEditada({ ...transaccionEditada, monto: e.target.value })}
                                                            className="border rounded-lg p-2 mb-2"
                                                            maxLength={10}
                                                        />

                                                        <h3 className="font-semibold">Estado:</h3>
                                                        <input
                                                            type="text"
                                                            value={transaccionEditada.estado}
                                                            onChange={(e) => setTransaccionEditada({ ...transaccionEditada, estado: e.target.value })}
                                                            className="border rounded-lg p-2 mb-2"
                                                            maxLength={10}
                                                        />

                                                        <div className="flex mt-4">
                                                            <button onClick={() => guardarTransaccionEditada(transaccion.id)}
                                                                className="bg-green-500 text-white rounded px-2 py-1 mr-2 w-40">Guardar</button>
                                                            <button onClick={() => setEditandoTransaccionId(null)}
                                                                className="bg-gray-500 text-white rounded px-2 py-1 w-40">Cancelar</button>
                                                        </div>
                                                    </div>
                                                ) : (
                                                    <div className="flex flex-col">
                                                        <span><strong>ID Usuario:</strong> {transaccion.idusuario}</span>
                                                        <span><strong>Método de Pago:</strong> {transaccion.metodo_pago_id}</span>
                                                        <span><strong>Monto:</strong> {transaccion.monto}</span>
                                                        <span><strong>Estado:</strong> {transaccion.estado}</span>
                                                    </div>
                                                )}
                                            </div>

                                            {transaccionSeleccionada === transaccion.id && !editandoTransaccionId && (
                                                <>
                                                    <div className="flex items-center ">
                                                        <button
                                                            onClick={(e) => {
                                                                e.stopPropagation();
                                                                editarTransaccion(transaccion.id, transaccion);
                                                            }}
                                                            className="bg-gray-500 text-white rounded px-2 py-1 mr-2 hover:bg-gray-400"
                                                        >
                                                            Editar Transacción
                                                        </button>

                                                        <button
                                                            onClick={(e) => {
                                                                e.stopPropagation();
                                                                confirmarEliminarTransaccion(transaccion.id);
                                                            }}
                                                            className="bg-red-600 text-white rounded px-2 py-1 mr-2 hover:bg-red-500"
                                                        >
                                                            Borrar Transacción
                                                        </button>
                                                    </div>
                                                    <div className=" mt-12  space-y-2">
                                                        <>
                                                            {/* Botón para Mostrar Métodos de Pago */}
                                                            <button
                                                                onClick={() => setComponenteActivo('metodospago')}
                                                                className={`px-4 py-2 rounded mr-2 ${componenteActivo === 'metodospago' ? 'bg-green-500 text-white' : 'bg-gray-500 text-white'}`}
                                                            >
                                                                Métodos de Pago
                                                            </button>

                                                            <button
                                                                onClick={() => setComponenteActivo('facturas')}
                                                                className={`px-4 py-2 rounded mr-2 ${componenteActivo === 'facturas' ? 'bg-green-500 text-white' : 'bg-gray-500 text-white'}`}
                                                            >
                                                                Facturas
                                                            </button>

                                                            {/* Mostrar el componente seleccionado */}
                                                            {componenteActivo === 'metodospago' && (
                                                                <MetodosPago transaccionId={transaccion.id} />
                                                            )}

                                                            {/* Mostrar el componente seleccionado */}
                                                            {componenteActivo === 'facturas' && (
                                                                <Facturas pagoId={transaccion.id} />
                                                            )}
                                                        </>
                                                    </div>
                                                </>
                                            )}
                                        </li>
                                    ))}
                                </ul>

                                {!mostrarFormulario && (
                                    <div className="flex">
                                        <button
                                            onClick={handleMostrarFormulario}
                                            className="bg-blue-500 text-white rounded px-4 py-2 mb-4 hover:bg-blue-400"
                                        >
                                            Agregar nueva transacción
                                        </button>
                                    </div>
                                )}

                                {mostrarFormulario && (
                                    <form onSubmit={handleAgregarTransaccion} className="flex flex-col space-y-4 mt-4" ref={formularioRef}>
                                        <h3 className="text-lg font-semibold">Agregar nueva Transacción</h3>
                                        <input
                                            type="text"
                                            value={nuevaTransaccion.idusuario}
                                            onChange={(e) => setNuevaTransaccion({ ...nuevaTransaccion, idusuario: e.target.value })}
                                            placeholder="ID Usuario"
                                            className="border rounded-lg p-2"
                                        />
                                        <input
                                            type="text"
                                            value={nuevaTransaccion.metodo_pago_id}
                                            onChange={(e) => setNuevaTransaccion({ ...nuevaTransaccion, metodo_pago_id: e.target.value })}
                                            placeholder="Método de Pago"
                                            className="border rounded-lg p-2"
                                        />
                                        <input
                                            type="number"
                                            value={nuevaTransaccion.monto}
                                            onChange={(e) => setNuevaTransaccion({ ...nuevaTransaccion, monto: e.target.value })}
                                            placeholder="Monto"
                                            className="border rounded-lg p-2"
                                        />
                                        <input
                                            type="text"
                                            value={nuevaTransaccion.estado}
                                            onChange={(e) => setNuevaTransaccion({ ...nuevaTransaccion, estado: e.target.value })}
                                            placeholder="Estado"
                                            className="border rounded-lg p-2"
                                        />
                                        <div className="flex space-x-4">
                                            <button type="submit" className="bg-green-500 rounded text-white px-4 py-2">
                                                Agregar Transacción
                                            </button>
                                            <button
                                                type="button"
                                                onClick={() => setMostrarFormulario(false)}
                                                className="bg-gray-500 text-white rounded px-4 py-2"
                                            >
                                                Cancelar
                                            </button>
                                        </div>
                                    </form>
                                )}

                                {mensajeExito && (
                                    <p className="text-pink-500 mt-2">Transacción agregada exitosamente</p>
                                )}
                            </div>
                        </div>
                    </main>

                </>             
        </>
    );
};

export default TransaccionesPagos;
